// @flow
import * as React from 'react';
import styled from 'styled-components';
import { isDefined } from 'utils/functional';
import Icon from 'components/Icon';
import Button from 'components/Button';
import Box from 'components/Box';
import { BodyMicro } from 'components/Text';
import { colors, transition, mediaRetina } from '../theme';

const Pill = styled(
  ({
    title,
    text,
    onClick,
    'aria-label': ariaLabel,
    active,
    outline,
    component,
    ...props
  }: {
    title: string,
    text: string,
    onClick: Function,
    active?: boolean,
    'aria-label'?: string,
    outline?: boolean,
    component?: React.ElementType
  }) => {
    const Component = component || Button;
    return (
      <Component
        borderRadius={20}
        p="2px 12px"
        height={32}
        aria-label={ariaLabel || title}
        title={title}
        onClick={onClick}
        {...props}
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="100%"
        >
          <BodyMicro
            tag="span"
            textOverflow="ellipsis"
            overflow="hidden"
            whiteSpace="nowrap"
          >
            {text}
          </BodyMicro>
          {(!isDefined(active) || active) && (
            <Box flex="0 0 auto" ml="8px">
              <Icon
                name="close"
                display="block"
                width="8px"
                height="9px"
                fill="currentColor"
                strokeWidth="2px"
              />
            </Box>
          )}
        </Box>
      </Component>
    );
  }
)`
  max-width: 100%;
  display: flex;
  align-items: center;
  ${props => `
    background: ${
      props.active
        ? colors.waterBlue
        : props.outline
        ? 'transparent'
        : colors.offWhite
    };
    color: ${
      props.active
        ? 'white'
        : props.outline
        ? colors.battleshipGrey
        : colors.waterBlue
    };
    ${
      props.outline && !props.active
        ? `
      box-shadow: 0 0 0 1px ${colors.aluminum} inset;
      &:hover {
        box-shadow: 0 0 0 1px transparent inset;
      }
      ${mediaRetina} {
        box-shadow: 0 0 0 1px ${colors.aluminum} inset;
        &:hover {
          box-shadow: 0 0 0 1px transparent inset;
        }
      }
    `
        : ''
    }
    &:hover {
      background: ${props.active ? colors.niceBlue : colors.waterBlue};
    }
  `}
  transition: all ${transition};
  &:hover{
    color: white;
  }
`;

export default Pill;
